// MOXIE: fallback para assets/header-menu.js#findMenuItem — usa element.querySelector('[ref="menuitem"]'),
// que no matchea el propio nodo. Si el primer pointerenter de una entrada (ej. mouse en línea recta
// desde abajo) llega con target = <a ref="menuitem"> en vez de su <li> padre, activate() no encuentra
// el item y el dropdown no abre (el :hover CSS sí sigue aplicando). Reconcilia re-disparando el evento
// sobre el <li>, mismo mecanismo que el propio header-menu.js usa para su workaround de Safari.
const RECONCILE_THROTTLE_MS = 50;

function watchHeaderMenu(headerMenu) {
  let lastCheck = 0;

  function reconcile(x, y) {
    const now = performance.now();
    if (now - lastCheck < RECONCILE_THROTTLE_MS) return;
    lastCheck = now;

    const target = document.elementFromPoint(x, y);
    const listItem = target instanceof Element ? target.closest('.menu-list__list-item') : null;
    if (!listItem || !headerMenu.contains(listItem)) return;

    const link = listItem.querySelector('[ref="menuitem"]');
    if (!link || link.getAttribute('aria-expanded') !== 'false') return;

    listItem.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
  }

  function onPointerMove(event) {
    reconcile(event.clientX, event.clientY);
  }

  headerMenu.addEventListener('pointerenter', () => {
    document.addEventListener('pointermove', onPointerMove);
  });
  headerMenu.addEventListener('pointerleave', () => {
    document.removeEventListener('pointermove', onPointerMove);
  });
}

document.querySelectorAll('header-menu').forEach(watchHeaderMenu);
